import { useMutation } from "@tanstack/react-query";
import { ISendAdminInvitePayload, sendUserInvitation } from "../actions/sendInviteUser";
import { useAppDispatch } from "../../../redux/hooks/redux";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";

export const useSendUserInvitation = () => {
  const dispatch = useAppDispatch();
  return useMutation({
    mutationKey: ["sendUserInvitation"],
    mutationFn: (vars: ISendAdminInvitePayload) => sendUserInvitation(vars),
    onSuccess: () => {
      dispatch(fetchBenefits());
    },
  });
};
